import { useYearContext } from "../hooks/useYearContext";
import SmallGame from "../components/SmallGame";
import { useEffect, useState } from "react";
import Image from "../components/Image";
import { Game } from "../types";

const Home = () => {
  const { current } = useYearContext();

  const [games, setGames] = useState<Game[]>([]);
  const [live, setLive] = useState(true);
  const [time, setTime] = useState(0);

  const getTime = async () => {
    const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/changes`);
    const json = await response.json();
    if (response.ok) {
      if (time < new Date(json[0].time).valueOf()) {
        getGames();
        setTime(new Date(json[0].time).valueOf());
      } else {
      }
    } else {
      alert(json.error);
    }
  };

  const getGames = async () => {
    const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/live?year=${current?.year}`);
    const json = await response.json();
    if (response.ok) {
      if (json.length === 0) {
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/upcoming?year=${current?.year}`);
        const json = await response.json();
        if (response.ok) {
          setGames(json);
          setLive(false);
        } else {
          alert(json.error);
        }
      } else {
        setLive(true);
        setGames(json);
      }
    } else {
      alert(json.error);
    }
  };

  useEffect(() => {
    if (current && time === 0) {
      getTime();
    }
    let interval = setInterval(() => {
      if (current) {
        getTime();
      }
    }, 30000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [current, time]);

  return (
    <div className="">
      <div className="flex w-screen  justify-center items-center relative bg-black -z-10  ">
        <img src="/img/main_bg.jpg" alt="" className="  z-10 w-screen 6 relative  aspect-auto md:object-cover " />
        <img src="/img/main_bg.jpg" alt="" className="fixed  z-10 w-screen top-16  left-0 aspect-auto md:object-cover " />
        <img
          src="/img/main_text.png"
          alt=""
          className="fixed left-1/2 lg:top-1/2  z-10 max-w-[80vw]  lg:max-w-[900px]  aspect-auto object-cover translate-x-[-50%] lg:translate-y-[-50%]"
        />
        <div className="absolute bottom-0 left-0 w-screen h-[20vh] bg-gradient-to-b from-transparent to-black/30 md:to-black/50 z-20"></div>
      </div>
      <div className="w-screen bg-[#befb00] z-40">
        <div className="logos py-7 md:py-16">
          <div className="logos-slide w-max  child:inline-block child:mx-6 md:child:mx-12 ">
            <img src="/img/sponsors/MSVVM_black.svg" alt="logo MSVVM" />
            <img src="/img/sponsors/NIVAM_black.svg" alt="logo NIVAM" />
            <img src="/img/sponsors/KSK_black.svg" alt="logo KSK" />
            <img src="/img/sponsors/SDB_black.svg" alt="logo SDB" />
            <img src="/img/sponsors/3horky_black.svg" alt="logo 3H" />
            <img src="/img/sponsors/DOMKA_black.svg" alt="logo Domka" />
            <img src="/img/sponsors/EastWave_horizontal_black.svg" alt="logo Eastwave" />
            <img src="/img/sponsors/Webex_black.svg" alt="logo Webex" />
            <img src="/img/sponsors/PS_black.svg" alt="logo PS" />
            <img src="/img/sponsors/CAMKE_black.svg" alt="logo Camke" />
          </div>
          <div className="logos-slide w-max  child:inline-block child:mx-6 md:child:mx-12   ">
            <img src="/img/sponsors/MSVVM_black.svg" alt="logo MSVVM" />
            <img src="/img/sponsors/NIVAM_black.svg" alt="logo NIVAM" />
            <img src="/img/sponsors/KSK_black.svg" alt="logo KSK" />
            <img src="/img/sponsors/SDB_black.svg" alt="logo SDB" />
            <img src="/img/sponsors/3horky_black.svg" alt="logo 3H" />
            <img src="/img/sponsors/DOMKA_black.svg" alt="logo Domka" />
            <img src="/img/sponsors/EastWave_horizontal_black.svg" alt="logo Eastwave" />
            <img src="/img/sponsors/Webex_black.svg" alt="logo Webex" />
            <img src="/img/sponsors/PS_black.svg" alt="logo PS" />
            <img src="/img/sponsors/CAMKE_black.svg" alt="logo Camke" />
          </div>
          <div className="logos-slide w-max  child:inline-block child:mx-6 md:child:mx-12   ">
            <img src="/img/sponsors/MSVVM_black.svg" alt="logo MSVVM" />
            <img src="/img/sponsors/NIVAM_black.svg" alt="logo NIVAM" />
            <img src="/img/sponsors/KSK_black.svg" alt="logo KSK" />
            <img src="/img/sponsors/SDB_black.svg" alt="logo SDB" />
            <img src="/img/sponsors/3horky_black.svg" alt="logo 3H" />
            <img src="/img/sponsors/DOMKA_black.svg" alt="logo Domka" />
            <img src="/img/sponsors/EastWave_horizontal_black.svg" alt="logo Eastwave" />
            <img src="/img/sponsors/Webex_black.svg" alt="logo Webex" />
            <img src="/img/sponsors/PS_black.svg" alt="logo PS" />
            <img src="/img/sponsors/CAMKE_black.svg" alt="logo Camke" />
          </div>
        </div>
      </div>
      <div className={"bg-gradient-to-b bg-white from-black/30 via-black/10 to-black/50"}>
        {current !== undefined && (
          <div className="w-screen relative  z-30 ">
            {current.status === "ongoing" && (
              <div className="md:flex flex-col justify-around md:w-[30vw] pt-12 md:mt-0 md:h-[70vh]   mx-auto ">
                {games.length > 0 && (
                  <div className="w-4/5 md:w-full mx-auto md:mx-0 z-20 ">
                    {live && (
                      <div className="bg-accent text-white text-center py-2 md:py-5">
                        <h2>Aktuálne hrané zápasy</h2>
                      </div>
                    )}
                    {!live && (
                      <div className="bg-white border border-accent text-accent text-center py-2 md:py-5">
                        <h2>Nasledujúce zápasy</h2>
                      </div>
                    )}
                    {games.map((e) => (
                      <SmallGame key={e.ID} e={e} className={" bg-white "} />
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        <div className=" py-64 ">
          <div className="w-[80vw]  md:w-[60vw] mx-auto   text-black z-50  ">
            <div className="md:w-[80%] md:child:text-3xl child:text-2xl child:leading-9 child:font-medium z-50 ">
              <p className="mb-10">
                VHT je celoslovenský hokejbalový turnaj určený pre hráčov v katégórii U15. Každoročne sa v metropole východu stretávajú chlapci zo saleziánskych
                stredísk z celého Slovenska, aby si zmerali svoje sily na ihrisku.
              </p>
              <p>
                Ide o udalosť, ktorá oslovuje nielen hráčov, ale aj ich rodiny a priateľov. Na turnaji vládne vskutku unikátna atmosféra, ktorá vytvára
                nezabudnuteľné chvíle nielen na ihrisku, ale aj mimo neho.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center relative pb-24   ">
          <Image src={"/img/Frame 154.jpg"} className={"w-4/5 md:w-2/5 z-40"} />
        </div>
      </div>
    </div>
  );
};

export default Home;
